<script>
import ChannelItem from '@/components/watchmen/channels/ChannelItem.vue';

export default {
  name: "MonitoringChannel",
  props: {
    channel: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  components: { ChannelItem }
}
</script>
<template>
  <div class="bg-gray-100 rounded-md px-3 py-2 d-flex">
    <div v-if="!!index" class="text-mono text-gray-400 font-weight-bold pr-2">{{ index }}</div>
    <div>
      <strong>{{ channel.watchman.name }}</strong>
      <ChannelItem :channel="channel" />
    </div>
  </div>
</template>